import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import Disclaimer from '../Disclaimer';
import { saloonImageOptions } from './views/saloon'

class Saloon extends Component {
    constructor(props) {
		super(props);
		this.handleFabricChange = this.handleFabricChange.bind(this);
    }

	handleFabricChange(newValue) {
		let configuration = this.props.configuration;
		configuration.Fabric = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

    render() {
		let imageOptions = saloonImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>


					<h1><Trans defaults='SALOON' /></h1>
					<h2><Trans defaults='Fabrics' /></h2>
					<MaterialSelector options={this.props.fabricOptions} label={this.props.configuration.Fabric.label} value={this.props.configuration.Fabric} onChange={this.handleFabricChange} />


                    <Disclaimer />
                   

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Saloon);


// WEBPACK FOOTER //
// ./src/X43MK2/Saloon.js